import { z } from 'zod';
import { fallback } from '@/lib/utils/zodFallback';

// ─── List search schema ────────────────────────────────────────────────────────

export const productionsListSearch = z.object({
  tab: fallback(z.string(), 'productions'),
  page: fallback(z.number().int().min(0), 0),
  count: fallback(z.number().int().min(10).max(500), 20),
  sort: z.string().optional(),
  filters: z.record(z.string(), z.array(z.string())).optional(),
  // Processes tab state
  pPage: fallback(z.number().int().min(0), 0),
  pCount: fallback(z.number().int().min(10).max(500), 20),
  pFilters: z.record(z.string(), z.array(z.string())).optional(),
});

export type ProductionsListSearch = z.infer<typeof productionsListSearch>;

// ─── List meta ──────────────────────────────────────────────────────────────────

export interface ProductionsListMeta {
  total: number;
  page: number;
  count: number;
  lastPage?: number;
}
